import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Container,
  makeStyles,
  TableBody,
  TableHead,
  TablePagination,
  Grid,
} from "@material-ui/core";
import { productsServices } from "../services";
import { AuthContext } from "../context";
import {
  SimpleToolbar,
  Loader,
  Drawer,
  StyledTableCell,
  StyledTableRow,
  BaseTable,
} from "../components";
import { useDrawer } from "../hooks";
import handleDownloadExcel from "../helpers/download-excel";
export default function MostRequestedProducts(props) {
  const classes = useStyles();
  const [products, setProducts] = useState([]);
  const { authState, signOut } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(100);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  // const [toast, setToast] = useState(false);
  // const [toastMessage, setToastMessage] = useState('');
  const [reload, setReload] = useState(false);
  const { isOpen, setIsOpen } = useDrawer();
  const tableHeader = useRef([
    "Ordenes creadas",
    "Nombre",
    "Molécula",
    "Registro",
    "Unidad de Negocio",
  ]);
  const tableBody = useRef([]);

  useEffect(() => {
    const tableData = products.map((product) => {
      return {
        "Ordenes creadas": product.count || "",
        Nombre: product.product.name || "",
        Molécula: product.product.molecule || "",
        Registro: product.product.isp || "",
        "Unidad de Negocio": product.laboratory.name || "",
      };
    });
    tableBody.current = tableData;
  }, [products]);

  useEffect(() => {
    setReload(false);
    getMostRequestedProducts("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, authState, reload]);

  const getMostRequestedProducts = async (text) => {
    try {
      setLoading(true);
      const { status, response } =
        await productsServices.getMostRequestedProducts({
          text,
          page,
          limit,
          token: authState.token,
        });
      setLoading(false);
      if (status === 200) {
        setProducts(response.orders);
        setLimit(response.limit);
        setCount(response.total);
        setPage(response.page);
      } else if (status === 401) {
        signOut();
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };
  const optionsToolbar = [
    {
      label: "Exportar excel",
      action: (e) => {
        handleDownloadExcel({
          filename: "Muestras mas asignadas",
          tableBody: tableBody.current,
          tableHeader: tableHeader.current,
        });
      },
    },
  ];
  return (
    <>
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container className={classes.container} style={{ flex: 1 }}>
        {loading && <Loader loading={true} />}
        <Grid item sm={12}>
          <div className={classes.root}>
            <Container maxWidth={false}>
              <SimpleToolbar
                isOpen={isOpen}
                setIsOpen={(value) => setIsOpen(value)}
                onFilter={(text) => getMostRequestedProducts(text)}
                options={optionsToolbar}
              />
              {/* <Toast message={toastMessage} open={toast} close={() => { setToast(false) }} /> */}
              <BaseTable tableId="tableProducts">
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell>Ordenes creadas</StyledTableCell>
                    <StyledTableCell>Nombre</StyledTableCell>
                    <StyledTableCell>Molecula</StyledTableCell>
                    <StyledTableCell>Registro</StyledTableCell>
                    <StyledTableCell>Unidad de negocio</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {products.map((product, index) => (
                    <StyledTableRow hover key={product._id}>
                      <StyledTableCell
                         
                      >
                        {product.count}
                      </StyledTableCell>
                      <StyledTableCell
                         
                      >
                        {product.product.name}
                      </StyledTableCell>
                      <StyledTableCell
                         
                      >
                        {product.product.molecule}
                      </StyledTableCell>
                      <StyledTableCell
                         
                      >
                        {product.product.isp}
                      </StyledTableCell>
                      <StyledTableCell
                         
                      >
                        {product.laboratory.name}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </BaseTable>
              <TablePagination
                labelRowsPerPage="Registros por página"
                component="div"
                count={count}
                onChangeRowsPerPage={(e) => {
                  setLimit(e.target.value);
                }}
                onChangePage={(e, page) => {
                  setPage(page + 1);
                }}
                page={page - 1}
                rowsPerPage={limit}
                rowsPerPageOptions={[10, 25, 50, 100]}
                classes={{ root: classes.pagination }}
              />
            </Container>
          </div>
        </Grid>
      </Grid>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  pagination: {
    color: theme.palette.secondary.main,
    [theme.breakpoints.down("xs")]: {
      position: "absolute",
      bottom: 0,
    },
  },
}));
